const format = {};
const defaultLocale = 'en-US';

format.number = (value, locale = defaultLocale) => {
  return Number(value).toLocaleString(locale);
};

format.date = (value, locale = defaultLocale) => {
  if (!value) {
    return '';
  }

  const d = new Date(value);
  return d.toLocaleDateString(locale);
};

export { format };
export default format;



// WEBPACK FOOTER //
// ./app/utils/format.js